import {
    initCallbackPopup,
    initObjectSlider,
    initPopup,
    initStocks
} from '../../../../common/scripts/common';
import CustomSelect from '../../../form/custom-select';
import Observer from '../../../../common/scripts/observer';
import ScrollBy from '../../../../components/scrollBy';
import tmplFlatsList from './templates/content.twig';
import tmplGroupFlatsList from '../group/templates/group-table-list.twig';
import tmplGroupList from './templates/group-content.twig';
import tmplNoResults from './templates/noresults.twig';
import tmplTitle from './templates/title.twig';
import {Utils} from '../../../../common/scripts/utils';

const observer = new Observer();

/**
 * 🚩🚩🚩🔴🔴🔴 - RED FLAG 🔴🔴🔴🚩🚩🚩
 * Не делать этот код донором параметрического поиска других проектов без полного рефакторинга
 */

class ParametricResult {
    constructor(options) {
        /**
         * Параметры
         */
        this.options = options;

        this.isFlatTypeInstance = options.isFlatType || false;

        /**
         * Целевой элемент
         */
        this.element = options.element ? options.element.querySelector('.j-parametric-result') : null;

        /**
         * Группировка по типам
         */
        this.group = 0;

        /**
         * ID группировки по типам, если есть
         * @type {false|String}
         */
        this.groupId = false;

        /**
         * Состояние открыт или нет (мобильная версия)
         * @type {boolean}
         */
        this.isOpenSort = false;

        /**
         * Флаг, со скидками или нет
         */
        this.hasDiscounts = false;

        /**
         * CSS-класс состояния загрузки
         * @type {string}
         */
        this.loadingClass = 'is-loading';
        this.activeClass = 'is-active';
        this.processClass = 'is-process';
        this.hiddenClass = 'is-hidden';
        this.selects = [];
        this.selectActionsQuery = {};
    }

    init() {
        if (!this.element) {
            return;
        }

        this._bindContext();
        this._initElements();
        this._initSelects(this.sortSelects);
        this._initSelects(this.discountSelects);
        this._initSelects(this.curactionSelects);
        this._subscribes();
        this._bindEvents();
    }

    /**
     * Инициализация элементов выдачи
     * @private
     */
    /* eslint-disable max-lines-per-function, max-statements, max-len */
    _initElements() {
        // Форма-обёртка фильтров в блоке результатов
        this.form = this.element.querySelector('.j-results-form');
        // Заголовок ("Найдено Х объектов")
        this.title = this.element.querySelector('.j-parametric-result__title');
        // Фильтр группировки по ЖК
        this.groupCheckbox = this.element.querySelector('.j-parametric__group-checkbox');
        this.group = this.groupCheckbox && this.groupCheckbox.checked;
        // Враппер группы
        this.groupInfoWrapper = this.element.querySelector('.j-group-info-wrapper');
        // Враппер со списком объектов
        this.flatListWrapper = this.element.querySelector('.j-parametric-result__content');
        // Список объектов
        this.flatList = this.element.querySelector('.j-parametric-result__content .flat-list');
        this.flatGroupList = this.element.querySelector('.j-group-flats-list');
        // Инпуты сортировки
        this.sortSelects = [...this.element
            .querySelectorAll('.j-parametric-result__content-wrapper .j-parametric-result__sort')];
        // Сортировка внутри группы
        this.selectSortGroup = [...this.element.querySelectorAll('.j-group-info-wrapper .j-parametric-result__sort')];
        this.sortInputs = Array.from(this.element.querySelectorAll('.j-parametric-result__sort input'));
        this.sortBtnMobile = this.element.querySelector('.j-sort-mobile-btn');
        this.sortBtnMobileClose = this.element.querySelector('.j-parametric-sort-close');
        this.sort = this.sortInputs.find((item) => {
            return item.checked;
        })?.value || null;
        // Селекты скидочности
        this.discountSelects = [...this.element
            .querySelectorAll('.j-parametric-result__content-wrapper .j-parametric-result__discount')];
        this.discountInputs = Array.from(this.element.querySelectorAll('.j-parametric-result__discount input'));
        // Чекбокс скидочности
        this.discountCheckbox = this.element.querySelector('.j-parametric-result__content-wrapper .j-parametric-result__discount-lite');
        this.discountBtnMobile = this.element.querySelector('.j-discount-mobile-btn');
        this.discountBtnMobileClose = this.element.querySelector('.j-parametric-discount-close');
        this.selectActions = [...this.element.querySelectorAll('.j-parametric__select_action-checkbox')];
        // Селекты скидочности
        this.curactionSelects = [...this.element
            .querySelectorAll('.j-parametric-result__content-wrapper .j-parametric-result__curaction')];
        // Кнопки смены вида
        this.viewButtons = Array.from(this.element.querySelectorAll('.j-parametric-result__view'));
        // Шапка табличного вида
        this.resultTableHead = this.flatListWrapper?.querySelector('.j-parametric-result__table-head');
        // Кнопка Показать ещё...
        this.showMoreBtn = this.element.querySelector('.j-parametric__more') || null;
        this.showMoreBtnText = this.showMoreBtn ? this.showMoreBtn.querySelector('.j-parametric__more-text') : null;
        // Враппер отсутствия результатов
        this.noResults = this.element.querySelector('.j-parametric-result__nothing');
        // Враппер контента результатов
        this.contentResults = this.element.querySelector('.j-parametric-result__content-wrapper');
        this.callbackForm = this.element.dataset.callbackFormSlug ?
            {
                slug      : this.element.dataset.callbackFormSlug,
                buttonText: this.element.dataset.callbackFormButtonText
            } :
            null;
        // Objects
        this._initObjects();

        this._initStocks();
    }
    /* eslint-enable max-lines-per-function, max-statements, max-len */

    _initSelects(selectsArray) {
        selectsArray.forEach((element) => {
            const select = new CustomSelect({
                elem: element
            });

            select.init();
            this.selects.push(select);
        });
    }

    initGroupSortSelect() {
        this._initElements();
        this._initSelects(this.selectSortGroup);
        this._bindGroupSelectEvents();
    }

    /**
     * Инициализирует карточки объектов
     * @private
     */
    _initObjects() {
        // Слайдер при наведении в объектах
        const objectsArray = Array.from(this.element.querySelectorAll('.j-object'));

        objectsArray.forEach((wrapper) => {
            initObjectSlider({wrapper});
            this._initPopups(wrapper, '.j-popup__object', initPopup);
        });
    }

    /**
     * Инициализирует попапы (сортировка, попапы бронирования)
     * @param {Object} wrapper - враппер
     * @param {String} selector - кнопки для инициализации попапов
     * @param {Function} method - метод для инициализации попапов
     * @private
     */
    _initPopups(wrapper, selector, method) {
        const popupButtons = Array.from(wrapper.querySelectorAll(`${selector}:not([data-init])`));

        if (!popupButtons.length) {
            return;
        }

        method(popupButtons);

        popupButtons.forEach((button) => {
            button.dataset.init = true;
        });
    }

    _initFlatTypesPopups() {
        const popupButtons = Array.from(document.querySelectorAll('.j-popup:not([data-init])'));

        if (popupButtons.length) {
            initPopup(popupButtons);

            popupButtons.forEach((button) => {
                button.dataset.init = true;
            });
        }
    }

    /**
     * Инициализирует попапы кладовок - план, бронирование
     * @private
     */
    _initPantryPopups() {
        const popupCallbackButtons = Array.from(document.querySelectorAll('.j-popup-callback:not([data-init])'));
        const popupReserveButtons = Array.from(document.querySelectorAll('.j-popup-reserve-pantry:not([data-init])'));
        const popupPlanButtons = Array.from(document.querySelectorAll('.j-popup-plan-pantry:not([data-init])'));

        if (popupCallbackButtons.length) {
            initCallbackPopup(popupCallbackButtons);

            popupCallbackButtons.forEach((button) => {
                button.dataset.init = true;
            });
        }

        if (popupReserveButtons.length) {
            initCallbackPopup(popupReserveButtons);

            popupReserveButtons.forEach((button) => {
                button.dataset.init = true;
            });
        }

        if (popupPlanButtons.length) {
            initPopup(popupPlanButtons);

            popupPlanButtons.forEach((button) => {
                button.dataset.init = true;
            });
        }
    }

    /**
     * Применяет данные с сервера к чекбоксам в результатах
     * @param {object} dataFilter - данные с сервера
     */
    setFilter(dataFilter) {
        if (dataFilter.filters) {
            Object.entries(dataFilter.filters).forEach(([, {type, data}]) => {
                if (type === 'checkbox') {
                    data.forEach((option) => {
                        const input = this.element.querySelector(`input[value="${option.value}"]`);

                        if (!input) {
                            return;
                        }

                        input.disabled = option.disabled;
                        input.checked = option.checked;
                    });
                }
            });
        }
    }

    /**
     * Запуск состояния загрузки
     */
    runLoading() {
        this.element.classList.add(this.loadingClass);
    }

    /**
     * Отмена состояния загрузки
     */
    stopLoading() {
        this.element.classList.remove(this.loadingClass);
    }

    /**
     * Обновляет результаты выдачи после поиска
     * @param {object} data - данные с сервера
     */
    setResult(data) {
        this._setNoResults(data.noResults);
        this.setMoreButton(data.more);
        this.groupInfoWrapper.classList.add(this.hiddenClass);
        const isContent = Boolean(this.title);

        if (isContent) {
            if (data.title) {
                this._replaceContent(this.title, data.title);
            }
            this._replaceContent(this.flatList, tmplFlatsList(data));
        } else {
            Utils.clearHtml(this.element);
            if (data.title) {
                Utils.insetContent(this.element, tmplTitle(data));
            }
            Utils.insetContent(this.element, tmplFlatsList(data));
            this._initElements();
            this._bindEvents();
        }
    }

    _initStocks() {
        const stockTags = [...document.querySelectorAll('.j-stock-tag')];

        initStocks(stockTags);
    }

    setResultGroupInfo(data) {
        this._replaceContent(this.groupInfoWrapper, tmplGroupList(data));
        this.contentResults?.classList.add(this.hiddenClass);
        this.groupInfoWrapper.classList.remove(this.hiddenClass);

        if (this.isFlatTypeInstance) {
            this._bindCardsEvents();
        }
    }

    _setNoResults(noResults) {
        Utils.clearHtml(this.noResults);
        if (noResults) {
            if (this.contentResults) {
                this.contentResults.classList.add(this.hiddenClass);
            }

            Utils.insetContent(this.noResults, tmplNoResults());
        } else if (this.contentResults) {
            this.contentResults.classList.remove(this.hiddenClass);
        }
    }

    /**
     * Обновляет/добавляет список квартир
     * @param {Object} data - объект, содержащий информацию о квартирах и акциях
     * @param {Boolean} isReplace - флаг, true, если необходимо заменить текущий список квартир
     */
    setFlatsList(data, isReplace = false) {
        if (!data.flats?.length && !data.parkings?.length && !data.commerces?.length && !data.pantrys?.length) {
            return;
        }

        if (this.callbackForm && (data.pantrys?.length || data.parkings?.length)) {
            data.callbackForm = this.callbackForm;
        }

        if (isReplace) {
            Utils.clearHtml(this.flatList);
        }

        Utils.insetContent(this.flatList, tmplFlatsList(data));
        this._bindCardsEvents();
        this._initPantryPopups();
    }

    /**
     * Обновляет список квартир после сортировки (в блоке выбранной группы)
     * @param {object} data - данные с сервера
     * @param {Boolean} isReplace - подменять ли данные
     */
    setGroupFlatsList(data, isReplace = false) {
        if (!data.flats || !data.flats.length) {
            return;
        }
        if (isReplace) {
            Utils.clearHtml(this.flatGroupList);
        }

        Utils.insetContent(this.flatGroupList, tmplGroupFlatsList(data));
    }

    /**
     * Обновляет список квартир после сортировки
     * @param {object} data - данные с сервера
     */
    setSortResult(data) {
        this.setFlatsList(data, true);
    }

    /**
     * Дополняет список квартир (Показать ещё)
     * @param {object} data - данные с сервера
     */
    setMoreResult(data) {
        this.setFlatsList(data, false);
        this.setMoreButton(data.more);
    }

    scrollToTop() {
        this.element.scrollIntoView({
            behavior: 'smooth'
        });
    }

    /**
     * Устанавливает новые данные в блок "Показать ещё"
     * @param {Object} more - объект с данными о количестве квартир
     */
    setMoreButton(more) {
        if (!this.showMoreBtn) {
            return;
        }

        this.showMoreBtn.classList.toggle(this.hiddenClass, !more?.more);

        if (more?.count) {
            this.showMoreBtn.dataset.shown = more.count;
        }

        if (this.showMoreBtnText && more?.text) {
            this.showMoreBtnText.innerHTML = more.text;
        }
    }

    /**
     * Инициализация элементов выдачи
     */
    reInitGroupElements() {
        this._initElements();
        this._bindGroupEvents();
    }

    _updateFilterGroupCheckbox() {
        if (this.options.updateFilterGroupCheckbox) {
            this.options.updateFilterGroupCheckbox(this.group);
        }
    }

    setResultGroupCheckboxState(state) {
        this.groupCheckbox.checked = state;
    }

    /**
     * Отправляет данные на сервер
     * @param {String} type - тип отправки
     * @param {Object} data - данные для отправки
     * @private
     */
    _send(type, data = {}) {
        if (!type) {
            return;
        }

        switch (type) {
            case 'sort':
                if (this.options.changeSort) {
                    this.options.changeSort(data);
                }
                break;
            case 'more':
                if (this.options.clickMore) {
                    this.options.clickMore(data);
                }
                break;
            case 'filter':
                if (this.options.changeGroup) {
                    this.options.changeGroup(data);
                }
                break;
            case 'groupInfo':
                if (this.options.changeGroupInfo) {
                    this.options.changeGroupInfo(data);
                }
                break;
            default:
                break;
        }
    }

    /**
     * Подписка на события обзёрвера
     * @private
     */
    _subscribes() {
        observer.subscribe('parametric:updateObjects', () => {
            this._initObjects();
        });

        observer.subscribe('custom-select:instant-close', (text) => {
            if (text && text.includes('скидкой')) {
                this.hasDiscounts = true;
            } else if (text && text.includes('Все')) {
                this.hasDiscounts = false;
            }

            this._closeSortMobile();
            this._closeDiscountMobile();
        });

        observer.subscribe('popup:refresh', () => {
            this._initPantryPopups();
        });

        observer.subscribe('parametric:reset', () => {
            if (this.form) {
                this.form.reset();
            }

            if (this.discountBtnMobile) {
                this.hasDiscounts = false;
                this.discountBtnMobile.classList.remove('is-active');
            }
        });

        observer.subscribe('filters:discounts', (value) => {
            if (this.discountCheckbox && this.discountCheckbox) {
                if (value === false) {
                    this.discountCheckbox.querySelector('input').removeAttribute('disabled', 'disabled');
                    this.discountBtnMobile.classList.remove('is-disabled');
                } else {
                    this.hasDiscounts = false;
                    this.discountCheckbox.querySelector('input').setAttribute('disabled', 'disabled');
                    this.discountBtnMobile.classList.remove('is-active');
                    this.discountBtnMobile.classList.add('is-disabled');
                }
            }
        });
    }

    _bindSelectEvents() {
        this.sortInputs.forEach((sortInput) => {
            sortInput.addEventListener('change', (event) => {
                this.group = this.groupCheckbox?.checked ? 1 : 0;
                this.sort = event.target.value;
                this._send('sort', this._collectData());
            });
        });

        this.selectActions.forEach((act) => {
            if (act.checked) {
                const val = act.getAttribute('value');

                this.selectActionsQuery[val] = val;
            }

            act.addEventListener('change', () => {
                const val = act.getAttribute('value');

                if (act.checked) {
                    this.selectActionsQuery[val] = val;
                }
                if (!act.checked) {
                    delete this.selectActionsQuery[val];
                }

                this._send('filter');
            });
        });

        this.discountInputs.forEach((discountInput) => {
            discountInput.addEventListener('change', () => {
                if (this.options.onDiscountChange) {
                    this.options.onDiscountChange(discountInput.value);
                }

                this.hasDiscounts = discountInput.value;
                this.group = this.groupCheckbox && this.groupCheckbox.checked ? 1 : 0;
                this._send('filter');
            });
        });
    }

    _bindGroupSelectEvents() {
        // eslint-disable-next-line
        this.sortGroupInputs = Array.from(this.element.querySelectorAll('.j-group-info-wrapper .j-parametric-result__sort input'));
        this.sortGroupInput = this.sortGroupInputs.find((item) => {
            return item.checked;
        })?.value || null;
        this.sortGroupInputs.forEach((sortGroupInputItem) => {
            sortGroupInputItem.addEventListener('change', (event) => {
                this.group = this.isFlatTypeInstance || this.groupCheckbox.checked ? 1 : 0;
                this.sortGroup = 1;
                this.sortGroupInput = event.target.value;
                this._send('groupInfo', this._collectData());
            });
        });
    }

    /* eslint-disable max-lines-per-function, max-statements, max-len */
    _bindEvents() {
        if (this.groupCheckbox) {
            this.groupCheckbox.addEventListener('change', (event) => {
                this.group = event.target.checked ? 1 : 0;

                if (this.resultTableHead) {
                    this.resultTableHead.classList.toggle('parametric-result__table-head_theme_group');
                }

                this._updateFilterGroupCheckbox();
                this._send('filter', {...!this.group && {group: this.group}});
            });
        }

        if (this.discountCheckbox) {
            this.discountCheckbox.addEventListener('change', (event) => {
                if (this.options.onDiscountChange) {
                    this.options.onDiscountChange(event.target.checked);
                }

                this._send('filter');
            });
        }

        this.viewButtons.forEach((viewButton) => {
            viewButton.addEventListener('click', () => {
                this._setView(viewButton);
                this.setTagsHideCount();
            });
        });

        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', this._showMore);
        }

        if (this.sortBtnMobile) {
            this.sortBtnMobile.addEventListener('click', this._openSortMobile.bind(this));
        }

        if (this.sortBtnMobileClose) {
            this.sortBtnMobileClose.addEventListener('click', this._closeSortMobile.bind(this));
        }

        if (this.discountBtnMobile) {
            this.discountBtnMobile.addEventListener('click', this._openDiscountMobile.bind(this));
        }

        if (this.discountBtnMobileClose) {
            this.discountBtnMobileClose.addEventListener('click', this._closeDiscountMobile.bind(this));
        }

        this._bindSelectEvents();
        this._bindCardsEvents();
        this.showMoreFlatInfo();
        this._initPantryPopups();
    }
    /* eslint-enable max-lines-per-function, max-statements, max-len */

    _bindGroupEvents() {
        this.groupCards = [...this.element.querySelectorAll('.j-parametric-group')];

        this.groupCards.forEach((groupCard) => {
            groupCard.addEventListener('click', () => {
                this.groupId = groupCard.dataset.id;
                this._send('groupInfo', {
                    groupInfo: 1,
                    groupId  : this.groupId
                });
                this._scrollTopContent();
            });
        });

        this.showMoreFlatInfo();
    }

    _scrollTopContent() {
        const contentBlock = document.querySelector('.j-parametric-content');

        if (contentBlock) {
            const headerHeight = document.querySelector('.j-header').offsetHeight;
            const scrollContentBlock = new ScrollBy();

            scrollContentBlock.init({
                speedAnimation: 400,
                position      : 'top',
                offset        : headerHeight
            });
            scrollContentBlock.scrollToElement(contentBlock);
        }
    }

    _backToGroupEvents() {
        this.groupId = false;
        this.contentResults.classList.remove(this.hiddenClass);
        this.groupInfoWrapper.classList.add(this.hiddenClass);
        this.showMoreFlatInfo();
        if (this.options.setActiveFilter) {
            this.options.setActiveFilter();
        }
    }

    backToGroup() {
        this.groupInfoBack = document.querySelector('.j-group-info__back');

        if (this.groupInfoBack) {
            this.groupInfoBack.addEventListener('click', () => {
                this._backToGroupEvents();
            });

            window.onpopstate = () => {
                this._backToGroupEvents();
            };
        }
    }

    _setOpenSortMobile() {
        this[this.isOpenSort ? '_closeSortMobile' : '_openSortMobile']();
    }

    /**
     * Разворачивает сортировку КОСТЫЛЬ!!
     * @private
     */
    _openSortMobile() {
        // КОСТЫЛЬ!!
        const sortList = this.selects[0];

        if (!sortList) {
            return;
        }

        this.sortBtnMobile.classList.add('is-active');
        document.querySelector('.j-wrapper').classList.add('is-active');
        sortList.isOpen = true;
        sortList.elem.classList.add(this.openClass);
        sortList.content.style.height = `${sortList.content.scrollHeight}px`;
        sortList._fixBody();
    }

    /**
     * Разворачивает попап скидочности КОСТЫЛЬ!!
     * @private
     */
    _openDiscountMobile() {
        // КОСТЫЛЬ!!
        const discountList = this.selects[1];

        if (!discountList) {
            return;
        }

        this.discountBtnMobile.classList.add('is-active');
        document.querySelector('.j-wrapper').classList.add('is-active');
        discountList.isOpen = true;
        discountList.elem.classList.add(this.openClass);
        discountList.content.style.height = `${discountList.content.scrollHeight}px`;
        discountList._fixBody();
    }

    /**
     * Сворачивает сортировку КОСТЫЛЬ!!
     * @private
     */
    _closeSortMobile() {
        // КОСТЫЛЬ!!
        const sortList = this.selects[0];

        if (!sortList) {
            return;
        }

        this.sortBtnMobile.classList.remove('is-active');

        document.querySelector('.j-wrapper').classList.remove('is-active');

        sortList.isOpen = false;
        sortList.content.style.height = '0px';
        setTimeout(() => {
            sortList.content.style.height = '';
        }, 300);
        sortList.elem.classList.remove(sortList.openClass);
        sortList._unfixBody();
    }

    /**
     * Сворачивает попап скидочности КОСТЫЛЬ!!
     * @private
     */
    _closeDiscountMobile() {
        // КОСТЫЛЬ!!
        const discountList = this.selects[1];

        if (!discountList) {
            return;
        }

        if (this.hasDiscounts === true) {
            this.discountBtnMobile.classList.add('is-active');
        } else if (this.hasDiscounts === false) {
            this.discountBtnMobile.classList.remove('is-active');
        }

        document.querySelector('.j-wrapper').classList.remove('is-active');

        discountList.isOpen = false;
        discountList.content.style.height = '0px';
        setTimeout(() => {
            discountList.content.style.height = '';
        }, 300);
        discountList.elem.classList.remove(discountList.openClass);
        discountList._unfixBody();
    }

    _bindCardsEvents() {
        this.showMoreFlatInfo();

        if (this.isFlatTypeInstance) {
            this._initPopups(document, '.j-popup', initPopup);
        }
    }

    _bindContext() {
        this._showMore = this._showMore.bind(this);
    }

    /**
     * Заменяет контент
     * @param {Node} element - элемент, контент которого будет заменен
     * @param {string} html - новый контент
     * @private
     */
    _replaceContent(element, html) {
        Utils.clearHtml(element);
        Utils.insetContent(element, html);
    }

    /**
     * Меняет вид вывода результатов
     * @param {HTMLElement} button - кнопка, на которую нажали
     * @private
     */
    _setView(button) {
        const view = button.dataset.view;

        this.viewButtons.forEach((viewButton) => {
            const method = button === viewButton ? 'add' : 'remove';

            viewButton.classList[method](this.activeClass);
        });

        this.flatListWrapper.classList.add(this.processClass);
        this.flatListWrapper.classList.toggle('parametric-result__flats_view_table', view === 'table');
        setTimeout(() => {
            this.flatListWrapper.classList.remove(this.processClass);
        }, 0);

        if (!this.resultTableHead) {
            return;
        }

        if (this.flatListWrapper.classList.contains('parametric-result__flats_view_table')) {
            this.resultTableHead.classList.add(this.activeClass);
        } else {
            this.resultTableHead.classList.remove(this.activeClass);
        }


        observer.publish('favorite:reInit');
        observer.publish('compare:reInit');
    }

    setTagsHideCount() {
        const tagsList = Array.from(this.flatListWrapper.querySelectorAll('.j-similar-tags'));

        tagsList.forEach((tagItem) => {
            if (tagItem.dataset.hidecount === '1') {
                tagItem.dataset.hidecount = '2';
            } else {
                tagItem.dataset.hidecount = '1';
            }

            this._initStocks();
        });
    }

    showMoreFlatInfo() {
        this.showMoreFlatBtns = [...this.element.querySelectorAll('.j-parametric-flat__mobile-more:not([data-init])')];

        this.showMoreFlatBtns.forEach((showMoreFlatBtn) => {
            showMoreFlatBtn.dataset.init = true;

            showMoreFlatBtn.addEventListener('click', (event) => {
                event.preventDefault();
                showMoreFlatBtn.classList.toggle('is-active');
                showMoreFlatBtn.closest('.j-parametric-flat').classList.toggle('is-active');
            });
            showMoreFlatBtn.dataset.init = 'true';
        });
    }

    /**
     * Показать ещё
     * @private
     */
    _showMore() {
        this.group = this.groupCheckbox?.checked ? 1 : 0;
        this._send('more', this._collectData());
    }

    /**
     * Собирает данные для отправки
     * @returns {Object} data
     * @private
     */
    _collectData() {
        const data = {};

        if (this.groupId) {
            data.groupId = this.groupId;
        }
        if (this.group) {
            data.group = this.group;
        }

        if (this.sortGroup) {
            data.sortGroup = this.sortGroup;
        }

        this._addLimit(data);

        return data;
    }

    /**
     * Добавляет кол-во выведенных квартир в данные для отправки
     * @param {Object} data - объект данных
     * @private
     */
    _addLimit(data) {
        if (!this.showMoreBtn) {
            return;
        }

        data.shown = this.showMoreBtn.dataset.shown;
    }
}

export default ParametricResult;
